import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  Renderer2,
  ChangeDetectorRef,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormsModule,
  ReactiveFormsModule, // ✅ ADD THIS
} from '@angular/forms';
import { Router } from '@angular/router';
import {
  LoginService,
  OfferedTripService,
  UserService,
} from '../../services/rest.service';
import { DarkModeService } from '../../services/dark-mode.service';
import { DomSanitizer } from '@angular/platform-browser';

import { NavController, ViewWillEnter } from '@ionic/angular';
import { AlertController } from '@ionic/angular';
import { profilePictureSrc } from '../../shared/utils/storage-url';
import {
  IonSpinner,
  IonTextarea,
  IonCheckbox,
  IonText,
  IonBadge,
  IonCol,
  IonRow,
  IonGrid,
  IonCardContent,
  IonCardSubtitle,
  IonCardTitle,
  IonCardHeader,
  IonItemDivider,
} from '@ionic/angular/standalone';
import {
  IonAccordionGroup,
  IonAvatar,
  IonFooter,
  IonSegment,
  IonSegmentButton,
  IonInput,
  IonTitle,
  IonButtons,
  IonToolbar,
  IonSelect,
  IonHeader,
  IonSelectOption,
  IonLabel,
  IonButton,
  IonItem,
  IonList,
  IonCard,
  IonIcon,
  IonContent,
  IonAccordion,
  IonPopover,
  IonTabs,
  IonTabBar,
  IonTabButton,
  IonFab,
  IonFabButton,
  IonModal,
  IonBackButton,
  IonLoading,
  IonNote,
} from '@ionic/angular/standalone';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { PopoverController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { ModalController } from '@ionic/angular';
import { ActionSheetController, Platform } from '@ionic/angular';
import { CarCameraModalComponent } from '../car-camera-modal/car-camera-modal.component';
import { ViewPhotoModalComponent } from '../view-photo-modal/view-photo-modal.component';
import { firstValueFrom } from 'rxjs';
import { ToastController } from '@ionic/angular';
import { ActivatedRoute } from '@angular/router';
import { PushNotificationService } from '../../services/push-notification.service';
import { LanguageService } from '@app/services/language.service';
import { AuthService } from '@app/services/auth.service';
import { APP_VERSION } from '@app/config/package-info';
import { DarkModeToggleComponent } from '../../components/dark-mode-toggle/dark-mode-toggle.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@Component({
  selector: 'app-profile',
  templateUrl: './profile.page.html',
  styleUrls: ['./profile.page.scss'],
  host: { class: 'ion-page' },
  standalone: true,
  providers: [PopoverController, ModalController],
  imports: [
    IonSpinner,
    IonItemDivider,
    IonCheckbox,
    IonSegmentButton,
    IonSegment,
    IonCardHeader,
    IonCardTitle,
    IonCardSubtitle,
    IonCardContent,
    IonGrid,
    IonRow,
    IonCol,
    IonText,
    HttpClientModule,
    IonAvatar,
    IonFooter,
    IonAccordionGroup,
    IonBadge,
    TranslateModule,
    CommonModule,
    IonTitle,
    FormsModule,
    IonSelect,
    IonTextarea,
    IonInput,
    IonButtons,
    IonHeader,
    IonSelectOption,
    IonLabel,
    IonButton,
    IonItem,
    IonList,
    IonCard,
    IonIcon,
    IonContent,
    IonPopover,
    IonToolbar,
    IonLoading,
    IonAccordion,
    IonTabs,
    IonTabBar,
    IonTabButton,
    IonFab,
    IonFabButton,
    IonModal,
    IonBackButton,
    DarkModeToggleComponent,
    IonNote,
  ],
})
export class ProfilePage implements OnInit, ViewWillEnter, OnDestroy {
  @ViewChild('fileInput') fileInput!: ElementRef;
  @ViewChild('video', { static: false }) video!: ElementRef<HTMLVideoElement>;
  profilePicture: string | null = null;
  previewUrl: string | null = null;
  imageLoaded = false;
  cameraOn = false;
  capturedPhoto: string | null = null; // store captured photo base64
  stream: MediaStream | null = null;
  selectedFile: File | null = null;
  userId: number | null = null;
  showUserDetails = false;
  isOwner = false;
  showImageLoader = true;
  isUploadingPhoto = false;
  isloading = false;
  private backButtonSubscription: Subscription | null = null;
  actionSheet: HTMLIonActionSheetElement | null = null;
  pageTitle = 'PROFILE.TITLE';
  readonly appVersion = APP_VERSION;
  fromPage: any;
  constructor(
    private route: ActivatedRoute,
    private alertCtrl: AlertController,
    private translate: TranslateService,
    private router: Router,
    private loginService: LoginService,
    public offerTripService: OfferedTripService,
    private sanitizer: DomSanitizer,
    private modalController: ModalController,
    private actionSheetController: ActionSheetController,
    private platform: Platform,
    private toastController: ToastController,
    private darkModeService: DarkModeService,
    public pushService: PushNotificationService,
    private languageService: LanguageService,
    private authService: AuthService,
    private userService: UserService,
    private cd: ChangeDetectorRef,
    private navCtrl: NavController,
  ) {
    // Initialize dark mode from service
    this.darkMode = this.darkModeService.isDarkMode();
  }

  fullName = '';
  email = '';
  phone = '';
  data: any;
  characteristics = '';
  isEditing = false;
  defaultPicture = 'assets/Portrait_Placeholder.png';
  currentLang: string = 'en';
  languageSelectOptions = {
    cssClass: 'profile-language-popover',
  };

  public brands: any[] = [];
  public colors: any[] = [];
  public selectedBrandId: number | null = null;
  public selectedModelId: number | null = null;
  public color_id: number | null = null;
  selectedColor: any = null;
  characteristicsTextValue: string = '';
  selectedTab: string = 'personal';
  showPopover = false;
  popoverEvent: any;

  selectedModel: any = null;
  public filteredModels: any[] = [];
  darkMode = false;
  allCharacteristics: string[] = [
    'non_smoker',
    'has_air_conditioning',
    'plays_music',
    'allows_pets',
    'talkative',
    'always_on_time',
    'can_carry_small_packages',
  ];
  selectedCharacteristics: string[] = [];
  allUserTrips: any[] = [];
  isModalOpen: boolean = false;
  currentUserId: number | null = null;
  isOwnProfile = false;
  docPopoverOpen = false; // controls the small actions popover
  docPopoverEvent: any = null; // stores the click event for the popover
  currentDocType: 'id' | 'license' | null = null; // which doc is being acted on
  idPreviewUrl: string | null = null; // shows ✓ badge when set
  licensePreviewUrl: string | null = null; // shows ✓ badge when set
  private viewedUserId: number | null = null;
  private loadedProfileUserId: number | null = null;
  private rideDetailsReturnState: any = null;
  private tripDetailsReturnState: any = null;
  isAdmin: boolean | null = false;
  profilePicUrl = this.profilePicture?.toString();
  private profilePicturePaths: string[] = [];

  get hasCustomProfilePicture(): boolean {
    const src = this.previewUrl || this.profilePicture;
    return !!src && !this.isDefaultProfilePicture(src);
  }

  async onImageError(event: Event) {
    const img = event.target as HTMLImageElement;
    this.imageLoaded = false;

    if (
      this.currentObjectUrl &&
      img.src === this.currentObjectUrl
    ) {
      this.useDefaultProfilePicture();
      return;
    }

    // Keep showing the local crop preview if we still have one.
    if (this.previewUrl && !this.isDefaultProfilePicture(this.previewUrl)) {
      this.showImageLoader = false;
      this.imageLoaded = true;
      img.src = this.previewUrl;
      this.cd.detectChanges();
      return;
    }

    this.showImageLoader = true;
    this.cd.detectChanges();

    const blobUrl = await this.loadProfilePictureBlob();
    if (blobUrl) {
      this.profilePicture = blobUrl;
      this.previewUrl = null;
      img.src = blobUrl;
      this.showImageLoader = false;
      this.imageLoaded = true;
      this.cd.detectChanges();
      return;
    }

    this.useDefaultProfilePicture();
  }
  async presentProfilePhotoActionSheet() {
    const buttons: any[] = [
      {
        text: this.translate.instant('ACTIONS.VIEW_PHOTO'),
        icon: 'eye',
        handler: () => this.viewPhoto(), // ✅ use the same preview method
      },
      {
        text: this.translate.instant('ACTIONS.TAKE_PHOTO'),
        icon: 'camera',
        handler: () => this.openProfileCameraModal(),
      },
      {
        text: this.translate.instant('ACTIONS.CHOOSE_FROM_GALLERY'),
        icon: 'image',
        handler: () => this.pickProfileFromGallery(),
      },
    ];

    const profilePicUrl = this.profilePicture?.toString() || '';
    if (
      profilePicUrl &&
      !profilePicUrl.includes('Portrait_Placeholder.png') &&
      !profilePicUrl.includes('safe:assets/Portrait_Placeholder.png')
    ) {
      buttons.push({
        text: this.translate.instant('ACTIONS.REMOVE_PHOTO'),
        icon: 'trash',
        role: 'destructive',
        handler: () => this.removeProfilePhoto(),
      });
    }

    // ✅ Assign to this.actionSheet instead of local variable
    this.actionSheet = await this.actionSheetController.create({
      header: this.translate.instant('PROFILE.PROFILE_PHOTO'),
      buttons,
      cssClass: 'photo-action-sheet',
    });

    this.actionSheet.present();
    // Subscribe to hardware back button
    this.backButtonSubscription =
      this.platform.backButton.subscribeWithPriority(9999, () => {
        if (this.actionSheet) {
          this.actionSheet.dismiss();
        }
      });

    // Cleanup after dismiss
    this.actionSheet.onDidDismiss().then(() => {
      this.actionSheet = null;
      this.backButtonSubscription?.unsubscribe();
      this.backButtonSubscription = null;
    });
  }

  /** Open profile photo camera modal */
  async openProfileCameraModal() {
    const modal = await this.modalController.create({
      component: CarCameraModalComponent,
      cssClass: 'camera-modal',
      componentProps: { photoType: 'profile' }, // 👈 just one type
    });

    modal.onDidDismiss().then(async (res) => {
      if (res.role === 'saved' && res.data) {
        this.previewUrl = res.data.preview; // instant UI feedback
        this.isUploadingPhoto = true;
        this.showImageLoader = false;
        this.cd.detectChanges();

        try {
          const preparedFile = await this.prepareFileForUpload(res.data.file);
          const formData = new FormData();
          formData.append('photo', preparedFile);
          formData.append('type', 'profile');
          console.log('form data', formData);

          const { id } = await this.uploadPhoto_profile(formData);
          await this.persistProfilePicture(id);
          await this.presentToast(
            this.translate.instant('PROFILE.profilePhotoUpdated'),
            'success',
          );
        } catch (err) {
          console.error('Failed to upload profile picture', err);
          await this.presentToast(
            this.translate.instant('PROFILE.profilePhotoUpdatedFailed'),
            'danger',
          );
        } finally {
          this.isUploadingPhoto = false;
          this.showImageLoader = false;
          this.imageLoaded = true;
          this.cd.detectChanges();
        }
      }
    });

    await modal.present();
  }
  // Helper method to display a toast
  private async presentToast(message: string, color: string) {
    const toast = await this.toastController.create({
      message: message,
      duration: 2000,
      position: 'top',
      color: color,
    });
    await toast.present();
  }

  async pickProfileFromGallery() {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';

    input.onchange = async (e: any) => {
      const rawFile: File = e.target.files?.[0];
      if (!rawFile) return;

      input.value = '';

      // 🔥 OPEN CROP MODAL
      const modal = await this.modalController.create({
        component: CarCameraModalComponent,
        cssClass: 'camera-modal',
        componentProps: {
          photoType: 'profile', // used for aspect ratio
          galleryFile: rawFile,
          aspectRatio: true,
          // gallery mode
        },
      });

      await modal.present();

      const { data, role } = await modal.onWillDismiss();
      if (role !== 'saved' || !data?.file) return;

      // ✅ CROPPED FILE
      await this.uploadCroppedProfilePhoto(data.file, data.preview);
    };

    input.click();
  }
  private async uploadCroppedProfilePhoto(file: File, preview: string) {
    this.previewUrl = preview;
    this.isUploadingPhoto = true;
    this.showImageLoader = false;
    this.cd.detectChanges();

    try {
      const preparedFile = await this.prepareFileForUpload(file);

      const formData = new FormData();
      formData.append('photo', preparedFile);
      formData.append('type', 'profile');

      const { id } = await this.uploadPhoto_profile(formData);

      await this.persistProfilePicture(id);
      this.selectedFile = preparedFile;

      await this.presentToast(
        this.translate.instant('PROFILE.profilePhotoUpdated'),
        'success',
      );
    } catch (err) {
      console.error('Failed to update profile picture', err);
      await this.presentToast(
        this.translate.instant('PROFILE.profilePhotoUpdatedFailed'),
        'danger',
      );
    } finally {
      this.isUploadingPhoto = false;
      this.showImageLoader = false;
      this.imageLoaded = true;
      this.cd.detectChanges();
    }
  }

  ngOnDestroy() {
    this.revokeCurrentObjectUrl();
  }

  async removeProfilePhoto() {
    try {
      await firstValueFrom(this.loginService.deleteProfilePicture());

      this.revokeCurrentObjectUrl();
      this.profilePicturePaths = [];
      this.profilePicture = this.defaultPicture;
      this.previewUrl = this.defaultPicture;
      if (this.data) {
        this.data.profile_picture = null;
      }
      this.authService.patchUser({ profile_picture: null });

      await this.presentToast(
        this.translate.instant('PROFILE.profileremoved'),
        'success',
      );
    } catch (err) {
      console.error('Failed to delete profile picture', err);
      await this.presentToast(
        this.translate.instant('PROFILE.profilePhotoremovedFailed'),
        'danger',
      ); // ❌ toast on error
    }
  }

  private async uploadPhoto_profile(
    formData: FormData,
  ): Promise<{ id: number; url: string }> {
    try {
      const res: any = await firstValueFrom(
        this.loginService.uploadPhoto_profile(formData),
      );
      return { id: res.id, url: res.url };
    } catch (err) {
      console.error('Upload failed via service', err);
      throw err;
    }
  }

  private async persistProfilePicture(mediaId: number): Promise<void> {
    const result = await firstValueFrom(
      this.loginService.uploadProfilePicture(String(this.userId), mediaId),
    );

    const profilePicturePath = result?.profile_picture;
    if (profilePicturePath) {
      if (this.data) {
        this.data.profile_picture = profilePicturePath;
      }
      this.authService.patchUser({
        profile_picture: profilePicturePath,
        profile_picture_url: result?.profile_picture_url,
      } as any);

      this.profilePicturePaths = this.profilePicturePathCandidates({
        profile_picture: profilePicturePath,
        profile_picture_url: result?.profile_picture_url,
      });
      this.profilePicture = profilePictureSrc(
        {
          profile_picture: profilePicturePath,
          profile_picture_url: result?.profile_picture_url,
        },
        this.defaultPicture,
      );

      // Keep the crop preview visible. Replacing [src] / resetting imageLoaded
      // without a new load event left the yellow spinner stuck until reload.
      this.showImageLoader = false;
      this.imageLoaded = true;
      this.cd.detectChanges();
      return;
    }

    this.loadedProfileUserId = null;
    await this.loadUserProfile();
  }

  private async prepareFileForUpload(file: File): Promise<File> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      const objectUrl = URL.createObjectURL(file);

      img.onload = () => {
        URL.revokeObjectURL(objectUrl);

        const maxDimension = 512;
        const scale = Math.min(1, maxDimension / Math.max(img.width, img.height));
        const canvas = document.createElement('canvas');
        canvas.width = Math.round(img.width * scale);
        canvas.height = Math.round(img.height * scale);

        const ctx = canvas.getContext('2d')!;
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

        canvas.toBlob(
          (blob) => {
            if (!blob) return reject(new Error('Failed to convert image.'));
            const newFile = new File(
              [blob],
              file.name.replace(/\.\w+$/, '.jpeg'),
              {
                type: 'image/jpeg',
              },
            );
            resolve(newFile);
          },
          'image/jpeg',
          0.82,
        );
      };

      img.onerror = () => {
        URL.revokeObjectURL(objectUrl);
        reject(new Error('Failed to load image.'));
      };
      img.src = objectUrl;
    });
  }

  openModal() {
    this.isModalOpen = true;
  }

  ngOnInit() {
    this.applyCachedUser();

    this.route.queryParams
      .pipe(
        map((params) => ({
          userId: params['userId']
            ? Number(params['userId'])
            : Number(this.authService.getUserId()),
          from: params['from'],
        })),
        distinctUntilChanged(
          (a, b) => a.userId === b.userId && a.from === b.from,
        ),
      )
      .subscribe((params) => {
      this.fromPage = params.from;
      const navState = window.history.state as any;
      if (this.fromPage === 'ride-details' && navState?.rideDetails) {
        this.rideDetailsReturnState = {
          rideDetails: navState.rideDetails,
          passengerCount: navState.passengerCount || 1,
          passengerData: navState.passengerData || {},
        };
      }
      if (this.fromPage === 'trip-details' && navState?.tripDetails) {
        this.tripDetailsReturnState = {
          tripDetails: navState.tripDetails,
          tripId: navState.tripId || navState.tripDetails?.id,
          passengerCount: navState.passengerCount || 1,
          passengerData: navState.passengerData || {},
        };
      }
      const loggedInId = Number(this.authService.getUserId());
      const nextViewedUserId = params.userId || loggedInId;
      const shouldLoadProfile =
        !this.data || this.loadedProfileUserId !== nextViewedUserId;

      this.viewedUserId = nextViewedUserId;
      this.currentUserId = loggedInId;
      this.isAdmin = this.authService.isAdmin();

      this.checkOwnership();
      if (shouldLoadProfile) {
        void this.loadUserProfile();
      }

      if (
        params.userId &&
        nextViewedUserId !== loggedInId &&
        this.router.url.split('?')[0] === '/profile'
      ) {
        this.router.navigate(['/profile/personal'], {
          queryParams: { userId: nextViewedUserId, from: this.fromPage },
          queryParamsHandling: 'merge',
          replaceUrl: true,
        });
      }
    });

    this.initLanguage();

    this.languageService.lang$.subscribe((lang) => {
      this.currentLang = lang;
      this.updateCharacteristicsText();
    });
  }

  // Helper for language to keep ngOnInit clean
  private initLanguage() {
    const savedLang = this.languageService.currentLang;
    const browserLang = this.translate.getBrowserLang();
    const supportedLangs = ['en', 'fr', 'ar'];

    let langToUse = 'en';
    if (savedLang && supportedLangs.includes(savedLang)) {
      langToUse = savedLang;
    } else if (browserLang && supportedLangs.includes(browserLang)) {
      langToUse = browserLang;
    }
    this.currentLang = langToUse;
  }
  checkOwnership() {
    if (!this.currentUserId) {
      this.isOwnProfile = false;
      return;
    }

    // if no userId passed in URL → it’s your own profile
    if (!this.viewedUserId) {
      this.isOwnProfile = true;
    } else {
      this.isOwnProfile = this.viewedUserId === this.currentUserId;
    }
  }

  goBack() {
    const state = window.history.state as any;

    if (this.fromPage === 'admin') {
      this.router.navigate(['/admin'], { queryParams: { tab: 'users' } });
      return;
    }

    if (this.fromPage === 'ride-details') {
      const returnState =
        this.rideDetailsReturnState ||
        (state?.rideDetails
          ? {
              rideDetails: state.rideDetails,
              passengerCount: state.passengerCount || 1,
              passengerData: state.passengerData || {},
            }
          : null);

      if (returnState) {
        this.router.navigate(['/ride-details'], { state: returnState });
      } else if (window.history.length > 1) {
        window.history.back();
      } else {
        this.router.navigate(['/home'], { replaceUrl: true });
      }
      return;
    }

    if (this.fromPage === 'trip-details') {
      const returnState =
        this.tripDetailsReturnState ||
        (state?.tripDetails
          ? {
              tripDetails: state.tripDetails,
              tripId: state.tripId || state.tripDetails?.id,
              passengerCount: state.passengerCount || 1,
              passengerData: state.passengerData || {},
            }
          : null);

      if (returnState?.tripId) {
        this.router.navigate(['/trip-details'], {
          queryParams: { trip_id: returnState.tripId },
          state: returnState,
        });
      } else if (window.history.length > 1) {
        window.history.back();
      } else {
        this.router.navigate(['/home'], { replaceUrl: true });
      }
      return;
    }

    this.router.navigate(['/profile'], {
      queryParams: this.viewedUserId ? { userId: this.viewedUserId } : {},
    });
  }

  goToSegment(segment: string) {
    void this.navCtrl.navigateForward(['/profile', segment], {
      queryParams: { userId: this.viewedUserId },
      queryParamsHandling: 'merge',
      animated: true,
    });
  }

  toggleDarkMode() {
    this.darkModeService.toggleDarkMode();
  }

  async viewPhoto() {
    let imageUrl: string;

    if (this.selectedFile) {
      // Correct: use the File with createObjectURL
      imageUrl = URL.createObjectURL(this.selectedFile);
    } else if (this.profilePicture) {
      imageUrl =
        typeof this.profilePicture === 'string'
          ? this.profilePicture
          : this.sanitizer.sanitize(4, this.profilePicture)!;
    } else {
      imageUrl = this.defaultPicture;
    }

    const modal = await this.modalController.create({
      component: ViewPhotoModalComponent,
      componentProps: { imageUrl },
      backdropDismiss: true,
    });

    await modal.present();
    await modal.onDidDismiss();

    if (this.selectedFile) URL.revokeObjectURL(imageUrl);
  }
  openProfile() {
    console.log('userId in profile:', this.userId);
    this.router.navigate(['/profile/personal'], {
      queryParams: {
        from: 'profile',
      },
      replaceUrl: true,
    });
  }

  ionViewWillEnter() {
    this.pageTitle = 'PROFILE.TITLE';
  }

  private applyCachedUser() {
    const user = this.authService.getUser();
    if (!user) return;

    this.fullName = user.full_name || this.fullName;
    this.email = user.email || this.email;
    this.phone = user.phone_number || this.phone;
    this.userId = user.id ?? this.userId;
    if (!this.data) {
      this.data = user;
    }
  }

  async loadUserProfile() {
    if (this.isloading) return;
    if (this.loadedProfileUserId === this.viewedUserId && this.fullName) {
      return;
    }
    this.isloading = true;

    try {
      const profile = this.viewedUserId
        ? await firstValueFrom(this.loginService.getUserById(this.viewedUserId))
        : await firstValueFrom(this.loginService.getProfile());

      this.populateProfile(profile);
      this.loadedProfileUserId = this.viewedUserId;
    } catch (err) {
      console.error('Failed to load user profile:', err);
    } finally {
      this.isloading = false;
    }
  }
  private populateProfile(profile: any): void {
    profile = profile?.user || profile;
    this.previewUrl = null;
    this.data = profile;
    this.userId = profile.user?.id ?? profile.id ?? null;

    this.fullName = this.normalizeTextValue(profile.full_name, [
      'full_name',
      'fullName',
      'name',
    ]);
    this.email = this.normalizeTextValue(profile.email, [
      'email',
      'email_address',
      'emailAddress',
    ]);
    this.phone = this.normalizePhoneNumber(profile.phone_number);
    const characteristics = profile.characteristics || {};
    this.characteristics = characteristics;

    this.selectedCharacteristics = Array.isArray(characteristics.traits)
      ? characteristics.traits
      : [];

    this.updateCharacteristicsText();

    if (profile.profile_picture || profile.profile_picture_url) {
      void this.loadProfilePicture(profile);
    } else {
      this.profilePicture = this.defaultPicture;
      this.showImageLoader = false;
    }
  }

  private normalizePhoneNumber(phone: unknown): string {
    if (phone === null || phone === undefined) return '';

    if (typeof phone === 'string' || typeof phone === 'number') {
      const value = String(phone).trim();
      return value === '[object Object]' ? '' : value;
    }

    if (typeof phone === 'object') {
      const phoneObject = phone as Record<string, unknown>;
      return this.normalizePhoneNumber(
        phoneObject['phone_number'] ??
          phoneObject['phoneNumber'] ??
          phoneObject['phone'] ??
          phoneObject['number'] ??
          phoneObject['e164Number'] ??
          phoneObject['internationalNumber'],
      );
    }

    return '';
  }

  private normalizeTextValue(value: unknown, keys: string[] = []): string {
    if (value === null || value === undefined) return '';

    if (typeof value === 'string' || typeof value === 'number') {
      const text = String(value).trim();
      return text === '[object Object]' ? '' : text;
    }

    if (Array.isArray(value)) {
      return this.normalizeTextValue(value[0], keys);
    }

    if (typeof value === 'object') {
      const objectValue = value as Record<string, unknown>;

      for (const key of keys) {
        if (objectValue[key] !== undefined && objectValue[key] !== null) {
          return this.normalizeTextValue(objectValue[key], keys);
        }
      }

      for (const fallbackKey of ['value', 'label', 'text', 'title']) {
        if (
          objectValue[fallbackKey] !== undefined &&
          objectValue[fallbackKey] !== null
        ) {
          return this.normalizeTextValue(objectValue[fallbackKey], keys);
        }
      }
    }

    return '';
  }

  getAcceptedReservationsCount(trip: any): number {
    if (!trip.reservations) return 0;
    return trip.reservations
      .filter((r: any) => r.status === 'accepted')
      .reduce((total: number, r: any) => total + r.passenger_count, 0);
  }

  formatLocalDateTime(isoString: string): string {
    const date = new Date(isoString);
    const offsetMs = date.getTimezoneOffset() * 60000;
    const local = new Date(date.getTime() - offsetMs);
    return local.toISOString().slice(0, 16);
  }

  private currentObjectUrl?: string;

  async loadProfilePicture(profileOrPath: any): Promise<void> {
    this.revokeCurrentObjectUrl();
    this.profilePicturePaths = this.profilePicturePathCandidates(profileOrPath);
    const nextPicture = profilePictureSrc(profileOrPath, this.defaultPicture);
    this.profilePicture = nextPicture;

    // If a local preview is already on screen, keep it visible. Resetting
    // imageLoaded while [src] stays the same never re-fires (load), which
    // left the yellow spinner stuck until a full page reload.
    const hasVisiblePreview =
      !!this.previewUrl && !this.isDefaultProfilePicture(this.previewUrl);

    if (hasVisiblePreview) {
      this.imageLoaded = true;
      this.showImageLoader = false;
      return;
    }

    this.imageLoaded = this.isDefaultProfilePicture(nextPicture);
    this.showImageLoader = !this.imageLoaded;
  }

  private async loadProfilePictureBlob(): Promise<string | null> {
    for (const path of this.profilePicturePaths) {
      try {
        const blob = await firstValueFrom(this.loginService.getProfileImage(path));
        if (
          !blob ||
          (blob.type &&
            blob.type !== 'application/octet-stream' &&
            !blob.type.startsWith('image/'))
        ) {
          continue;
        }

        this.revokeCurrentObjectUrl();
        this.currentObjectUrl = URL.createObjectURL(blob);
        return this.currentObjectUrl;
      } catch (err) {
        console.warn('Profile photo fallback failed:', path, err);
      }
    }

    return null;
  }

  private profilePicturePathCandidates(profileOrPath: any): string[] {
    const rawValues = [
      typeof profileOrPath === 'string'
        ? profileOrPath
        : profileOrPath?.profile_picture,
      typeof profileOrPath === 'string'
        ? null
        : profileOrPath?.profile_picture_url,
    ];

    const paths = rawValues.flatMap((value) => this.storagePathCandidates(value));

    return [...new Set(paths)];
  }

  private storagePathCandidates(value: unknown): string[] {
    if (typeof value !== 'string') return [];

    let path = value.replace(/\\/g, '/').trim();
    if (
      !path ||
      ['[]', '{}', 'null', 'undefined', '[object Object]'].includes(path) ||
      path.startsWith('blob:') ||
      path.startsWith('data:') ||
      path.startsWith('assets/')
    ) {
      return [];
    }

    const storageUrl = path.match(/^https?:\/\/[^/]+\/storage\/(.+)$/i);
    if (storageUrl) {
      path = storageUrl[1];
    } else if (/^https?:\/\//i.test(path)) {
      return [];
    }

    path = path.replace(/^\/?storage\//i, '').replace(/^\/+/, '');
    if (!path) return [];

    return path.includes('/') ? [path] : [path, `profile_pictures/${path}`];
  }

  private revokeCurrentObjectUrl() {
    if (!this.currentObjectUrl) return;

    URL.revokeObjectURL(this.currentObjectUrl);
    this.currentObjectUrl = undefined;
  }

  get notificationSummary(): string {
    const prefs = JSON.parse(localStorage.getItem('notificationPrefs') || '{}');

    const enabled: string[] = [];

    if (prefs.email) enabled.push('Email');
    if (prefs.whatsapp) enabled.push('WhatsApp');
    if (prefs.push) enabled.push('Push');

    if (enabled.length === 0) {
      return 'Notifications are off';
    }

    if (enabled.length === 1) {
      return `${enabled[0]} notifications enabled`;
    }

    if (enabled.length === 2) {
      return `${enabled[0]} and ${enabled[1]} notifications are enabled`;
    }

    return `${enabled.slice(0, -1).join(', ')} and ${enabled.slice(-1)} are enabled`;
  }

  onImageLoad() {
    this.showImageLoader = false;
    this.imageLoaded = true;
  }

  private useDefaultProfilePicture() {
    this.revokeCurrentObjectUrl();
    this.profilePicture = this.defaultPicture;
    this.previewUrl = null;
    this.showImageLoader = false;
    this.imageLoaded = true;
    this.cd.detectChanges();
  }

  private isDefaultProfilePicture(value: unknown): boolean {
    if (typeof value !== 'string') return false;

    const normalized = value.replace(/\\/g, '/');
    return (
      normalized === this.defaultPicture ||
      normalized.endsWith(`/${this.defaultPicture}`) ||
      normalized.includes('Portrait_Placeholder.png')
    );
  }

  getInitials(name: string): string {
    if (!name) return '';
    const parts = name.trim().split(' ');
    return parts
      .map((p) => p[0])
      .join('')
      .substring(0, 2)
      .toUpperCase();
  }

  get characteristicsText(): string {
    return this.selectedCharacteristics
      .map((item) => '• ' + this.translate.instant('CHARACTERISTICS.' + item))
      .join('\n');
  }

  updateCharacteristicsText() {
    this.characteristicsTextValue = this.selectedCharacteristics
      .map((item) => '• ' + this.translate.instant('CHARACTERISTICS.' + item))
      .join('\n');
  }

  toggleCharacteristic(item: string): void {
    const index = this.selectedCharacteristics.indexOf(item);
    if (index > -1) {
      this.selectedCharacteristics.splice(index, 1);
    } else {
      this.selectedCharacteristics.push(item);
    }
    this.updateCharacteristicsText();
  }

  onIdSelected(event: any) {
    const file: File = event?.target?.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => (this.idPreviewUrl = reader.result as string);
    reader.readAsDataURL(file);
  }

  async logout() {
    const header = this.translate.instant('LOGOUT.CONFIRM_TITLE');
    const message = this.translate.instant('LOGOUT.CONFIRM_MESSAGE');
    const cancelText = this.translate.instant('COMMON.CANCEL');
    const confirmText = this.translate.instant('TAB.LOGOUT');

    const alert = await this.alertCtrl.create({
      header,
      message,
      buttons: [
        {
          text: cancelText,
          role: 'cancel',
          handler: () => {
            console.log('Logout cancelled');
          },
        },
        {
          text: confirmText,
          role: 'confirm',
          handler: () => {
            this.authService.logout();
          },
        },
      ],
    });

    await alert.present();
  }

  requestAccountDeletion() {
    if (!this.currentUserId) {
      this.showToast(this.translate.instant('USER_DETAILS.FAILED_DELETE_USER'));
      return;
    }

    this.userService.requestDeleteOtp(this.currentUserId).subscribe({
      next: (res: any) => {
        const messageKey =
          res?.channel === 'whatsapp'
            ? 'USER_DETAILS.OTP_SENT_WHATSAPP'
            : 'USER_DETAILS.OTP_SENT_EMAIL';

        this.showToast(this.translate.instant(messageKey), 'success');
        void this.showDeleteOtpModal();
      },
      error: (err) => {
        const message =
          err?.status === 422
            ? this.translate.instant('USER_DETAILS.NO_OTP_CONTACT')
            : this.translate.instant('USER_DETAILS.FAILED_SEND_OTP');

        this.showToast(message);
        console.error('Delete OTP request failed:', err);
      },
    });
  }

  async showDeleteOtpModal() {
    const alert = await this.alertCtrl.create({
      header: this.translate.instant('USER_DETAILS.DELETE_ACCOUNT'),
      message: this.translate.instant('USER_DETAILS.DELETE_ACCOUNT_MESSAGE'),
      inputs: [
        {
          name: 'otp',
          type: 'text',
          placeholder: this.translate.instant('USER_DETAILS.SIX_DIGIT_CODE'),
        },
      ],
      buttons: [
        {
          text: this.translate.instant('ACTIONS.CANCEL'),
          role: 'cancel',
        },
        {
          text: this.translate.instant('COMMON.Confirm'),
          handler: (data) => {
            if (!data.otp) {
              this.showToast(this.translate.instant('USER_DETAILS.ENTER_OTP'));
              return false;
            }

            this.deleteAccountPermanently(data.otp);
            return true;
          },
        },
      ],
    });

    await alert.present();
  }

  deleteAccountPermanently(code: string) {
    if (!this.currentUserId) return;

    this.userService.deleteUser(this.currentUserId, 'wipe', code).subscribe({
      next: (res: any) => {
        this.showToast(
          res?.message || this.translate.instant('USER_DETAILS.ACCOUNT_DELETED'),
          'success',
        );
        this.authService.logout();
      },
      error: (err: any) => {
        this.showToast(
          err?.error?.message ||
            this.translate.instant('USER_DETAILS.FAILED_DELETE_USER'),
        );
        console.error('Account deletion failed:', err);
      },
    });
  }

  async showToast(message: string, color: string = 'danger') {
    const toast = await this.toastController.create({
      message,
      duration: 2200,
      color,
      position: 'top',
    });

    await toast.present();
  }

  switchLang(lang: string) {
    // 1️⃣ Save in local service
    this.languageService.setLanguage(lang);

    // 2️⃣ Change translation
    this.translate.use(lang);

    // 3️⃣ Update RTL/LTR
    const dir = lang === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.setAttribute('dir', dir);
    document.documentElement.setAttribute('lang', lang);
    document.body.setAttribute('dir', dir);

    // 4️⃣ Save language in localStorage (optional, remember after refresh)
    localStorage.setItem('lang', lang);

    // 5️⃣ Update backend so push notifications work
    this.userService.updateLanguage(lang).subscribe({
      next: () => console.log('Language saved on server'),
      error: (err) => console.error('Error saving language', err),
    });
  }

  getLanguageLabel(lang: string): string {
    switch (lang) {
      case 'fr':
        return 'Français';
      case 'ar':
        return 'العربية';
      case 'en':
      default:
        return 'English';
    }
  }
}
